import React from 'react';
import { useAtom } from 'jotai';
import { LinkOverlay, LinkOverlayContainer, Pill, Text } from '@web-for-marketing/react-ui';
import { selectedLanguageAtom } from '@atoms/appSettings';
import { BlogCardImage, BlogPill } from '@models/blogCards';
import { blogCard2Styles as blog2Classes } from './BlogCard2Style';
import { blogCardStyle as classes } from './BlogCardStyle';
import { isMobileAtom } from '@atoms/appSettings';
import { DateAndReadTime } from './DateAndReadTime';

export interface BlogCard2Props {
    title: string;
    linkPath: string;
    ariaLabel?: string;
    image: BlogCardImage;
    pillData?: BlogPill;
    publishedDateUtc: string | null;
    readMinutes?: number;
    className?: string;
    lazyLoad?: boolean;
}

export function BlogCard2({
    title,
    linkPath,
    ariaLabel,
    image,
    pillData,
    publishedDateUtc,
    readMinutes,
    className,
    lazyLoad = false,
}: BlogCard2Props): React.ReactElement {
    const [selectedLanguage] = useAtom(selectedLanguageAtom);
    const [isMobile] = useAtom(isMobileAtom);

    return (
        <LinkOverlayContainer css={blog2Classes.cardContainer} className={className}>
            <div css={blog2Classes.imageWrapper}>
                <img
                    css={classes.image}
                    src={!lazyLoad ? image.imagePath : undefined}
                    data-src={lazyLoad ? image.imagePath : undefined}
                    alt={image.imageAlt}
                />
            </div>
            <div css={blog2Classes.cardContent(!!pillData)}>
                {pillData ? (
                    <Pill
                        css={blog2Classes.categoryMargins}
                        renderLink={<a href={pillData.link}>{pillData.name}</a>}
                        variant='secondaryOutline'
                    />
                ) : null}
                <Text variant={isMobile ? 'body1' : 'h4'} component='p' weight='bold' css={blog2Classes.title}>
                    <LinkOverlay href={linkPath} aria-label={ariaLabel} css={blog2Classes.textTruncate}>
                        {title}
                    </LinkOverlay>
                </Text>
                {publishedDateUtc ? (
                    <DateAndReadTime
                        publishedDateUtc={publishedDateUtc}
                        selectedLanguage={selectedLanguage}
                        readMinutes={readMinutes}
                    />
                ) : null}
            </div>
        </LinkOverlayContainer>
    );
}
